import { gql } from "graphql-tag";

export const AdvertisedCountersFragment = gql`
  fragment AdvertisedCountersFragment on AdvertisementCounters {
    imps
    track
    creative
    id
    name
    position
  }
`;

export const YandexCountersFragment = gql`
  fragment YandexCountersFragment on YandexCounters {
    items {
      value
      utmConfig {
        key
        value
      }
    }
  }
`;

export const CountersFragment = gql`
  fragment CountersFragment on Counters {
    yandex {
      ...YandexCountersFragment
    }
    advertisement {
      ...AdvertisedCountersFragment
    }
  }
  ${YandexCountersFragment}
  ${AdvertisedCountersFragment}
`;
